import React, { useEffect, useState } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";

import ConfirmButton from "../../../../common/components/ConfirmButton";
import ssnBlockingService from "../../../../services/ssnBlocking/services";
import { TextField } from "@material-ui/core";
import ClaimsWrapper from "../../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../../shared/ClaimLists/Claim.Aml.All.List";

const UserBlockInfo = ({
  currentUser,
  ssnBlock,
  getBlockInfo,
  blockSsn,
  unblockSsn,
}) => {
  const [reason, setReason] = useState("");
  let isBlocked =
    ssnBlock.fetched &&
    ssnBlock.data.Ssn === currentUser.SSN &&
    ssnBlock.data.IsBlocked;

  useEffect(() => {
    if (currentUser) getBlockInfo(currentUser.SSN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  if (!currentUser || !ssnBlock.fetched) {
    return <CircularProgress />;
  }

  return (
    <div>
      {isBlocked ? (
        <React.Fragment>
          <span style={{ color: "red" }}>
            User is blocked for reason:{" "}
            {ssnBlock.data.Reason ? ssnBlock.data.Reason : "no reason stated"}
          </span>{" "}
          <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
            <ConfirmButton
              label="Remove blockade for user"
              action={() => {
                unblockSsn(currentUser.SSN);
              }}
            ></ConfirmButton>
          </ClaimsWrapper>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <span style={{ color: "green" }}>User is not Blocked </span>
          <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
            <ConfirmButton
              label="block user"
              action={() => {
                blockSsn(currentUser.SSN, reason);
              }}
            >
              <div>
                <TextField
                  label="reason for bloking?"
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                />
              </div>
            </ConfirmButton>
          </ClaimsWrapper>
        </React.Fragment>
      )}
    </div>
  );
};

export default ssnBlockingService(UserBlockInfo);

/*
const UserBlockLoader = ({ currentUser }) => {


  return <_Block userSsn={currentUser.SSN} />;
};


blockSsn: (ssn, reason) => {
  dispatch(block_ssn(ssn, reason));
},
unblockSsn: ssn => {
  dispatch(unblock_ssn(ssn));
},
*/
